import { IEquipeResponse, IEquipesResponse } from '../models/equipe.model';

export const EQUIPES_MOCK: IEquipesResponse = {
  results: [
    {
      equipe: '1a2b3c4d-1111-2222-3333-444455556666',
      codigo: 'EQP001',
      titulo: 'Equipe de Desenvolvimento',
      descricao: 'Equipe responsável pelo desenvolvimento do sistema',
      tenant: 662,
      padrao: true,
      mestre: false,
      usuarios: [
        {
            guid: '7f8e9d0a-7777-8888-1234-000011112222',
            nome: 'Callyel Alves',
            email: 'callyelalves@nasajon.com.br'
        },
        {
            guid: '7f8e9d0a-7777-8888-4321-000011112222',
            nome: 'Ronaldinho Gaúcho',
            email: 'ronaldin@nasajon.com.br'
        },
      ]
    },
    {
      equipe: '7f8e9d0a-7777-8888-9999-000011112222',
      codigo: 'EQP002',
      titulo: 'Equipe de Suporte',
      descricao: 'Equipe que atende chamados e suporte técnico',
      tenant: 662,
      padrao: false,
      mestre: true,
      usuarios: [
        {
            guid: '7f8e9d0a-7777-8888-0000-000011112222',
            nome: 'Neymar Junior',
            email: 'neymar@nasajon.com.br'
        }
      ]
    }
  ]
};

export function createEquipeMock(request: any): IEquipeResponse {
  return {
    equipe: 'guid-' + Math.floor(Math.random() * 1000),
    codigo: request.codigo,
    titulo: request.titulo,
    descricao: request.descricao,
    tenant: 1,
    mestre: request.mestre
  };
}
